<template lang="pug">
.address-field
  b-field(
    label="Address"
    :type="errors.has('street') ? 'is-danger' : ''"
    :message="errors.has('street') ? errors.first('street') : ''"
  )
    b-input(
      type="text"
      name="street"
      icon="map-marker"
      v-model="address.street"
      @input="update"
      v-validate="validations"
    )
  b-field(grouped)
    b-field(
      label="City"
      :type="errors.has('city') ? 'is-danger' : ''"
      :message="errors.has('city') ? errors.first('city') : ''"
      expanded
    )
      b-input(
        type="text"
        name="city"
        v-model="address.city"
        @input="update"
        v-validate="validations"
      )
    b-field(
      label="State"
      :type="errors.has('state') ? 'is-danger' : ''"
      :message="errors.has('state') ? errors.first('state') : ''"
    )
      b-select(
        name="state"
        v-model="address.state"
        vv-name="state"
        data-vv-value-path="selected"
        v-validate="validations"
        @input="update"
      )
        option(
          v-for="state in states"
          :key="state.abbreviation"
          :value="state.abbreviation"
        ) {{ state.name }}
    b-field(
      label="Zipcode"
      :type="errors.has('zipcode') ? 'is-danger' : ''"
      :message="errors.has('zipcode') ? errors.first('zipcode') : ''"
      v-validate="validations"
    )
      b-input(
        type="text"
        name="zipcode"
        v-model="address.zipcode"
        @input="update"
        v-validate="validations"
      )
</template>

<script>
import _ from 'lodash';
import USStates from '@/data/us_states.json';

export default {
  name: 'address-field',
  computed: {
    completed() {
      return _.compact([
        this.address.street,
        this.address.city,
        this.address.state,
        this.address.zipcode,
      ]).length === 4;
    },
    addressString() {
      if (this.completed) {
        let string = [
          this.address.street,
          this.address.city,
          this.address.state,
        ].join(', ');
        string += ` ${this.address.zipcode}`;
        return string;
      }
      return null;
    },
    validations() {
      return this.required ? 'required' : null;
    },
  },
  created() {
    this.states = USStates;
  },
  data() {
    return {
      address: {
        state: null,
      },
      states: [],
    };
  },
  methods: {
    update() {
      if (this.completed) this.$emit('input', this.addressString);
    },
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.field.is-grouped {
  & > .field {
    margin-bottom: 0;
  }
}
@media (max-width: $tablet) {
  .field.is-grouped {
    flex-flow: column;
    .field {
      margin-left: 0;
      margin-bottom: 1.25rem;
    }
  }
}
</style>
